import { PlusOutlined } from '@ant-design/icons';

import { CxSurveyQuestionProps } from '../Survey';
import cls from './SurveyAddRow.module.css';

interface Props {
  list: CxSurveyQuestionProps[];
  setList: (question: CxSurveyQuestionProps[]) => void;
  category: string;
  hasNewRow: boolean;
  setHasNewRow: (flag: boolean) => void;
  hasAlterName?: boolean;
  maxLength: number;
}

export const SurveyAddRow = (
  { list, setList, category, hasNewRow, setHasNewRow, maxLength }: Props,
) => {
  const addRow = () => {
    const newQuestion: CxSurveyQuestionProps = {
      answer: null,
      answeredByUser: false,
      category,
      id: null,
      isEnabled: true,
      isRequired: false,
      isSelected: false,
      name: '',
      nameClient: '',
      options: [
        { value: 'yes', label: 'Sí', idx: 'yes' },
        { value: 'no', label: 'No', idx: 'no' },
      ],
      position: list.length + 1,
      type: 'yes-no',
      idx: Date.now().toString(),
    };
    setList([...list, newQuestion]);
    setHasNewRow(true);
  };

  return hasNewRow || list.length >= maxLength ? null : (
    <div className={cls.wrap}>
      <div className={cls.addRow}>
        <button className={cls.addBtn} onClick={addRow}>
          <PlusOutlined className={cls.addBtnIcon} />
        </button>
      </div>
    </div>
  );
};
